<div class="login_form">
 
    <div class="text-center mb-4 pb-2">
      <p class="">Welcome to </p>
      <h1 class="tenMT">DELIVERY PAL</h1>
      <h2 class="tenMT">Back office</h2>
    </div>
    <form [formGroup]="loginForm" (ngSubmit)="onLogin()">
       <div class="alert text-center" *ngIf="errorApi">
          {{errorMessage}}
          <mat-icon (click)="errorApi=false">close</mat-icon>
      </div>
       <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>User Name</mat-label>
          <input matInput type="text"  autocomplete="off" formControlName="user_name" />
          <mat-error *ngIf="loginForm.get('user_name')?.errors?.required && submitted">Required</mat-error>
        </mat-form-field>
      </div>
      <div class="field-row">
        <mat-form-field appearance="outline">
          <mat-label>Password</mat-label>
          <input matInput type="password" autocomplete="off" formControlName="password" />
          <mat-error *ngIf="loginForm.get('password')?.errors?.minlength && submitted">Please enter at least 6 characters</mat-error>
          <mat-error *ngIf="loginForm.get('password')?.errors?.required && submitted">Required</mat-error>
        </mat-form-field>
      </div>
  
      <div class="d-flex justify-content-center">
        <button mat-flat-button type="submit" color="primary" class="login-btn"  >
          Log in
        </button>
      </div> 
    </form>
    <div class="text-center">
      <p class="greytxt" [routerLink]="['/forgot-password']">Forgot your password?</p>
    </div>
   </div>
  